/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { GenderPolicy } from 'app/shared/model/enumerations/gender-policy.model';

export interface IWard {
  id?: string;
  name?: string | null;
  tempClosed?: boolean | null;
  dateClosed?: number | null;
  description?: string | null;
  info?: string | null;
  roomNoStart?: number | null;
  roomNoEnd?: number | null;
  roomPrefix?: string | null;
  modifiedBy?: string | null;
  modifiedTime?: number | null;
  createdBy?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  genderPolicy?: keyof typeof GenderPolicy | null;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IWard> = {
  tempClosed: false,
  active: false,
};
